import { render, staticRenderFns } from "./PublicLayout.vue?vue&type=template&id=7acd5450&scoped=true&"
import script from "./PublicLayout.vue?vue&type=script&lang=ts&"
export * from "./PublicLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PublicLayout.vue?vue&type=style&index=0&id=7acd5450&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acd5450",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
